module.exports = __webpack_public_path__ + "img/LogoNO-full.sorthvid-1.b83aa436.png";